import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import bem from 'utils/bem';
import { useMobile } from 'utils/media';
import { Dialog } from '@mui/material';
import Model from '../../../../../model';
import Text from 'components/Text';

import './index.sass';
import Icon from 'components/Icon';
import FeedbackForm from 'forms/forms/FeedbackForm';

const { block, el } = bem('feedback-form-modal');

const FeedbackFormModal = () => {

    const { modal, feedbackForm } = Model;
    const { isMobile } = useMobile();
    const { isFeedbackFormOpen, closeFeedbackForm, openFeedbackForm } = modal;
    const { submitSuccess } = feedbackForm;

    const handleClose = () => {
        closeFeedbackForm();
    }

    useEffect(() => {
        if (submitSuccess && !isFeedbackFormOpen) {
            openFeedbackForm();
        }
    }, [submitSuccess])

    return (
        <Dialog
            className={ block({'submit-success': submitSuccess}) }
            open={ isFeedbackFormOpen }
            onClose={ handleClose }
            fullWidth={ true }
            fullScreen={ isMobile }
            maxWidth={ 'md' }
            scroll={ 'body' }
            PaperProps={ {
                sx: {
                    maxWidth: 1024,
                    margin: '0 auto',
                    width: 1024,
                    borderRadius: isMobile ? 0 : '20px'
                }
            } }
        >
            <div className={ el('content') }>
                <div className={ el('left') }/>
                <div className={ el('right') }>
                    <div className={el('form')}>
                        <div className={el('title')}>
                            <Text serif>У вас есть вопросы или пожелания? Напишите нам</Text>
                        </div>
                        <FeedbackForm useRecaptcha={false} userAgreementMod={'full'} buttonMod={'gold'}/>
                    </div>
                </div>
                <div className={el('header')}>
                    <div className={el('close')} onClick={handleClose}><Icon name={'x'}/></div>
                </div>
            </div>
        </Dialog>
    )
}

export default observer(FeedbackFormModal);
